import React from 'react'
import * as S from './styled'

const ClickLinkCard = ({ infoCard }) => {
    
    const handleTag = (eventLabel) => {
        if (window && window.dataLayer)
            window.dataLayer.push({
            'event': 'servicos_para_voce',
            'action': 'clicou_btn',
            'clique': eventLabel
        })
    }

    return (
        <S.ClickLink href={infoCard.service_link} onClick={() => handleTag(infoCard.service_title)}>
            <S.ExameCards data-testid="ExameCard-div">
                <S.Division data-testid="Division-div">
                    <S.ImgCard src={infoCard.service_image.localFile.url} data-testid="ImgCard-img" alt={infoCard.service_title}/>
                    <S.DivFlex data-testid="DivFlex-div">
                        <S.PreTitle data-testid="PreTitle-p">
                            {infoCard.tag}
                        </S.PreTitle>
                        <S.Title data-testid="Title-h3">
                            {infoCard.service_title}
                        </S.Title>
                        <S.Text data-testid="Text-p">
                            {infoCard.service_text}
                        </S.Text>
                        <S.KnowMoreContainer data-testid="KnowMoreContainer-div">
                          <S.KnowMore data-testid="KnowMore-p">
                            Saiba mais
                          </S.KnowMore>
                          <S.SVG>
                            <svg
                              width="8"
                              height="11"
                              viewBox="0 0 8 11"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M7.27911 5.4399C7.2793 5.29211 7.24795 5.14598 7.18718 5.01126C7.12641 4.87655 7.0376 4.75634 6.92668 4.65867L1.88777 0.225677C1.72079 0.0855656 1.50562 0.0163439 1.28827 0.0328133C1.07092 0.0492827 0.868641 0.150136 0.724683 0.313808C0.580725 0.477479 0.506516 0.690979 0.517924 0.908653C0.529332 1.12633 0.625452 1.3309 0.78573 1.47863L5.19207 5.35496C5.20416 5.36556 5.21385 5.37862 5.22049 5.39327C5.22713 5.40792 5.23057 5.42382 5.23057 5.4399C5.23057 5.45599 5.22713 5.47188 5.22049 5.48653C5.21385 5.50118 5.20416 5.51425 5.19207 5.52485L0.78573 9.40118C0.700525 9.47267 0.630471 9.56048 0.579687 9.65944C0.528902 9.7584 0.498412 9.86651 0.490008 9.97742C0.481604 10.0883 0.495455 10.1998 0.530748 10.3053C0.566042 10.4108 0.622066 10.5081 0.695525 10.5916C0.768984 10.6752 0.858397 10.7432 0.95851 10.7916C1.05862 10.8401 1.16742 10.8681 1.27849 10.8739C1.38957 10.8797 1.50069 10.8633 1.60532 10.8255C1.70995 10.7878 1.80598 10.7295 1.88777 10.6541L6.92487 6.22249C7.03606 6.12464 7.12516 6.00426 7.18623 5.86933C7.24731 5.7344 7.27897 5.58801 7.27911 5.4399Z"
                                fill="#4B4B4B"
                              />
                            </svg>
                          </S.SVG>
                        </S.KnowMoreContainer>
                    </S.DivFlex>
                </S.Division>
            </S.ExameCards>
        </S.ClickLink>
    )
}


export default ClickLinkCard
